import { render, staticRenderFns } from "./TransferHelp.vue?vue&type=template&id=63d260f5&scoped=true"
import script from "./TransferHelp.vue?vue&type=script&lang=js"
export * from "./TransferHelp.vue?vue&type=script&lang=js"
import style0 from "./TransferHelp.vue?vue&type=style&index=0&id=63d260f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d260f5",
  null
  
)

export default component.exports